var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.world-icon-st0{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6898 2.33008V2.69908C11.6898 3.68908 10.8798 4.49908 9.88983 4.49908H8.08983V6.29908C8.08983 6.79408 7.68483 7.19908 7.18983 7.19908H5.38983V8.99908H10.7898C11.2848 8.99908 11.6898 9.40408 11.6898 9.89908V12.5991H12.5898C13.3908 12.5991 14.0658 13.1301 14.2998 13.8591C15.4698 12.5811 16.1988 10.8711 16.1988 8.99908C16.1988 5.98408 14.3268 3.39208 11.6898 2.33008ZM6.28983 12.5991V11.6991L1.98783 7.39708C1.87083 7.91008 1.79883 8.45008 1.79883 8.99908C1.79883 12.6621 4.55283 15.6861 8.08983 16.1361V14.3991C7.09983 14.3991 6.28983 13.5891 6.28983 12.5991Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "world-icon-st0",
    d: "M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM8.091 16.137C4.554 15.687 1.8 12.663 1.8 9C1.8 8.451 1.872 7.911 1.989 7.398L6.291 11.7V12.6C6.291 13.59 7.101 14.4 8.091 14.4V16.137ZM14.301 13.86C14.067 13.131 13.401 12.6 12.591 12.6H11.691V9.9C11.691 9.405 11.286 9 10.791 9H5.391V7.2H7.191C7.686 7.2 8.091 6.795 8.091 6.3V4.5H9.891C10.881 4.5 11.691 3.69 11.691 2.7V2.331C14.328 3.393 16.2 5.985 16.2 9C16.2 10.872 15.471 12.582 14.301 13.86Z",
    fill: "#050038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldIcon);
export default __webpack_public_path__ + "static/media/world-icon.c45eb3893842c796155d43f5caa1dff3.svg";
export { ForwardRef as ReactComponent };